import { useRetailer } from "@faire/retailer-visitor-shared/hooks/retailer/useRetailer";
import { useSettingAndAssignMigrateRetailerStore } from "@faire/retailer-visitor-shared/settings/useSettingMigrateRetailerStore";
import { useRetailerStore } from "@faire/retailer-visitor-shared/stores/domain/RetailerStore";
import { IRetailer } from "@faire/web-api--source/indigofair/data/IRetailer";
export var useInsider = function() {
    var shouldUseHooksMigration = useSettingAndAssignMigrateRetailerStore();
    var retailer = useRetailer().retailer;
    var _useRetailerStore = useRetailerStore([
        "isInsider",
        "isEligibleForInsider",
        "shouldShowInsider",
        "insiderMembershipState",
        "shouldShowInsiderSignupIncentive"
    ]), isInsiderControl = _useRetailerStore.isInsider, isEligibleForInsiderControl = _useRetailerStore.isEligibleForInsider, shouldShowInsiderControl = _useRetailerStore.shouldShowInsider, insiderMembershipStateControl = _useRetailerStore.insiderMembershipState, shouldShowInsiderSignupIncentiveControl = _useRetailerStore.shouldShowInsiderSignupIncentive;
    var _retailer_insider_membership_state;
    var insiderMembershipState = (_retailer_insider_membership_state = retailer === null || retailer === void 0 ? void 0 : retailer.insider_membership_state) !== null && _retailer_insider_membership_state !== void 0 ? _retailer_insider_membership_state : IRetailer.InsiderMembershipState.NOT_ELIGIBLE;
    var isInsider = insiderMembershipState === IRetailer.InsiderMembershipState.ACTIVE;
    var isEligibleForInsider = insiderMembershipState === IRetailer.InsiderMembershipState.ELIGIBLE || insiderMembershipState === IRetailer.InsiderMembershipState.CHURNED;
    var shouldShowInsider = insiderMembershipState !== IRetailer.InsiderMembershipState.NOT_ELIGIBLE;
    var shouldShowInsiderSignupIncentive = !!(retailer === null || retailer === void 0 ? void 0 : retailer.show_insider_signup_offer);
    if (shouldUseHooksMigration) {
        return {
            isInsider: isInsider,
            isEligibleForInsider: isEligibleForInsider,
            shouldShowInsider: shouldShowInsider,
            insiderMembershipState: insiderMembershipState,
            shouldShowInsiderSignupIncentive: shouldShowInsiderSignupIncentive
        };
    }
    return {
        isInsider: isInsiderControl,
        isEligibleForInsider: isEligibleForInsiderControl,
        shouldShowInsider: shouldShowInsiderControl,
        insiderMembershipState: insiderMembershipStateControl,
        shouldShowInsiderSignupIncentive: shouldShowInsiderSignupIncentiveControl
    };
};
